import { network } from 'services/network';

export const deleteCardAssociatedDocument = ({ id }) => {
    const url = `api/bo/deleteCardAssociatedDocument?docId=${id}`;
    return network.post(url).then((response) => response.data);
};
